import dataSiteMap from './siteMap.json';

export function removeWidow(text) {
	if (window.innerWidth >= 500 && text.indexOf(' ') > -1) { //text has at least 1 space
		if (text.match(/ /g).length > 2) { //text has more than 2 spaces
			if (text.substr(text.lastIndexOf(' ') + 1).length < 10) { //last word is less than ten characters long
				return text.substr(0, text.lastIndexOf(' ')) + '\xa0' + text.substr(text.lastIndexOf(' ') + 1);
			}
		}
	}

	return text;
}

export function getMeta(culture, section, page) {
	let meta = {
		title: 'Nyxoid',
	}

	if (dataSiteMap[culture]) {
		if (!section && dataSiteMap[culture].meta) {
			meta.title = dataSiteMap[culture].meta.title;

			if (dataSiteMap[culture].meta.description !== '') {
				meta.description = dataSiteMap[culture].meta.description;
			}

			if (dataSiteMap[culture].meta.keywords !== '') {
				meta.meta = {
					keywords: dataSiteMap[culture].meta.keywords,
				}
			}
		} else if (dataSiteMap[culture].navigation[section]) {
			if (dataSiteMap[culture].navigation[section].pages) {
				for (const sitemapPage of dataSiteMap[culture].navigation[section].pages) {
					if (sitemapPage.key === page && sitemapPage.meta) {
						meta.title = sitemapPage.meta.title;

						if (sitemapPage.meta.description !== '') {
							meta.description = sitemapPage.meta.description;
						}

						if (sitemapPage.meta.keywords !== '') {
							meta.meta = {
								keywords: sitemapPage.meta.keywords,
							}
						}
					}
				}
			}
		}
	}

	return meta;
}

export function setAlternatePageLinks(culture, section, page) {
	const oldLinks = document.querySelectorAll('head [data-apl]');

	for (const oldLink of oldLinks) {
		oldLink.parentNode.removeChild(oldLink);
	}

	if (culture === 'global') {
		return null;
	}

	const alternatePages = [];
	const domain = window.location.protocol + '//' + window.location.host;

	for (const site of Object.keys(dataSiteMap)) {
		if (site !== 'global' && dataSiteMap[site].live) {
			if (dataSiteMap[site].navigation[section]) {
				if (dataSiteMap[site].navigation[section].pages.filter((item) => {return item.live === true && item.key === page && !(culture !== site && section === 'hcp' && dataSiteMap[site].hcpLogin)}).length > 0) {
						//page is a content page not protected by password
						alternatePages.push({
							culture: site,
							cultureCode: dataSiteMap[site].cultureCode,
							href: domain + '/' + site + '/' + section + '/' + page,
						});
				} else if (dataSiteMap[site].navigation.legal.pages.filter((item) => {return item.live === true && item.key === page}).length > 0) {
					//page is a section legal page
					alternatePages.push({
						culture: site,
						cultureCode: dataSiteMap[site].cultureCode,
						href: domain + '/' + site + '/' + section + '/' + page,
					});
				}
			} else if (dataSiteMap[site].navigation.legal.pages.filter((item) => {return item.live === true && item.key === section}).length > 0) {
				//page is a legal page
				alternatePages.push({
					culture: site,
					cultureCode: dataSiteMap[site].cultureCode,
					href: domain + '/' + site + '/' + section,
				});
			} else if (!section && !page) {
				//page is a landing page
				alternatePages.push({
					culture: site,
					cultureCode: dataSiteMap[site].cultureCode,
					href: domain + '/' + site,
				});
			}
		}
	}

	for (const alternatePage of alternatePages) {
		const newLink = document.createElement('link');

		newLink.setAttribute('data-apl', '');
		newLink.setAttribute('href', alternatePage.href);
		newLink.setAttribute('hreflang', alternatePage.cultureCode);
		newLink.setAttribute('rel', 'alternate');

		document.getElementsByTagName('head')[0].appendChild(newLink);
	}
}

export function setLanguage(culture) {
	let lang = 'en';

	if (culture !== 'global' && dataSiteMap[culture]) {
		lang = dataSiteMap[culture].cultureCode.substr(0, 2);
	}

	document.getElementsByTagName('html')[0].setAttribute('lang', lang);
}



// WEBPACK FOOTER //
// ./src/utilities.js